module.exports = __webpack_public_path__ + "static/media/drafts_empty_mobile.d893fe93.svg";